import {Component, OnInit} from '@angular/core';
import {acceptCookie, getCookie} from '../../utils/cookie.utils';

const COOKIE_NAME = 'isApplyCookie';

const COOKIE_VALUE = 'true';

@Component({
  selector: 'app-cookie-warn',
  templateUrl: './cookie-warn.component.html',
  styleUrls: ['./cookie-warn.component.css'],
})
export class CookieWarnComponent implements OnInit {
  isApplied = true;

  constructor() {
  }

  ngOnInit(): void {
    if (getCookie(COOKIE_NAME) !== COOKIE_VALUE) {
      this.isApplied = false;
    }
  }

  acceptCookie(): void {
    acceptCookie(COOKIE_NAME, COOKIE_VALUE);

    this.isApplied = true;
  }
}
